module.exports = __webpack_public_path__ + "img/arrow-right.88fc1ae0.svg";